import createActions from '../config/actions/createActions';
import { action } from '@play-co/replicant';
import {
  resetStreakBattleRoyale,
  setStreakBattleRoyaleLastMilestoneSeen,
  setStreakBattleRoyaleStatus,
} from './streakbattleroyale.modifiers';
import {
  StreakBattleRoyaleStatus,
  StreakBattleRoyaleTheme,
} from './streakbattleroyale.ruleset';
import { clamp } from '../utils';
import {
  getStreakBattleRoyaleGoal,
  getStreakBattleRoyaleLastMilestoneSeen,
} from './streakbattleroyale.getters';

/** Development mode only, not allowed in production  */
export const match2StreakBattleRoyaleCheats = createActions({
  /**
   * Soft or hard reset the streak event sate.
   */
  cheat_streakBattleRoyaleReset: action((state, hardReset: boolean, api) => {
    if (hardReset) {
      delete state.streak;
      return;
    }
    resetStreakBattleRoyale(state);
  }),

  /**
   * Set the ongoing event progress milestone.
   * Resetting straight to it if it's lower than the current checkpoint,
   * otherwise it will progress to it with animation.
   *
   * If the milestone is the goal, then set event status to 'completed',
   * otherwise set it to 'active' as the event should still be ongoing at those checkpoints.
   */
  cheat_streakBattleRoyaleProgress: action((state, milestone: number, api) => {
    const goal = getStreakBattleRoyaleGoal(state);
    const now = api.date.now();
    milestone = clamp(milestone, 0, goal);
    state.streak!.milestone = milestone;
    setStreakBattleRoyaleStatus(
      state,
      milestone === goal ? 'completed' : 'active',
      now,
    );

    // Bypass the seen cache if the milestone is lower than the current checkpoint
    if (milestone < getStreakBattleRoyaleLastMilestoneSeen(state)) {
      setStreakBattleRoyaleLastMilestoneSeen(state, milestone);
    }
  }),

  /**
   * Force set streak event status
   */
  cheat_streakBattleRoyaleSetStatus: action(
    (state, status: StreakBattleRoyaleStatus, api) => {
      const now = api.date.now();

      setStreakBattleRoyaleStatus(state, status, now);
    },
  ),

  /**
   * Force set streak event theme
   */
  cheat_streakBattleRoyaleSetTheme: action(
    (state, theme: StreakBattleRoyaleTheme, api) => {
      state.streak!.theme = theme;
    },
  ),
});
